import React from 'react';
import { View, type ViewProps } from 'react-native';

import { useThemeColor } from '@/core/hooks/useThemeColor';

export type ThemedViewProps = Omit<ViewProps, 'children'> & {
  lightColor?: string;
  darkColor?: string;
  children?: React.ReactNode;
};

export function ThemedView({ style, lightColor, darkColor, children, ...otherProps }: ThemedViewProps) {
  const backgroundColor = useThemeColor(
    {
      ...(lightColor && { light: lightColor }),
      ...(darkColor && { dark: darkColor }),
    },
    'background'
  );

  return (
    <View style={[{ backgroundColor }, style]} {...otherProps}>
      {children}
    </View>
  );
}
